import { ref, computed } from 'vue';

import { tokenStorage, addAccount, type StoredAuth } from '@/platform/auth-runtime/token-storage';
import { startWs, stopWs } from '@/shared/lib/ws/ws';
import { isNonNullable } from '@/shared/utils/is';
import { defineStore } from 'pinia';

// Pinia wrapper around the on-disk token snapshot.
//
// `setAuth(snapshot, acName)` writes the 3 keys + (optionally) appends to
// the recent-accounts list. Empty account names intentionally skip that append.

export const useAuthStore = defineStore('auth', () => {
  const snapshot = ref<StoredAuth | null>(tokenStorage.read());
  const isAuthed = computed(() => isNonNullable(snapshot.value));

  function setAuth(next: StoredAuth, acName?: string): void {
    snapshot.value = next;
    tokenStorage.write(next);
    if (acName) addAccount(acName, next.aid);
    void startWs();
  }

  function clearAuth(): void {
    snapshot.value = null;
    clearPersistedAuth();
  }

  function clearPersistedAuth(): void {
    tokenStorage.clear();
    stopWs();
  }

  return { snapshot, isAuthed, setAuth, clearAuth, clearPersistedAuth };
});
